import { Tab, TabGroup } from '@amzn/meridian';
import {
  trafficCampaignsRootPath,
  trafficProjectAssetsPath,
  trafficProjectEventsPath,
  trafficProjectJASAssetsPath,
} from 'components/Paths';
import { find } from 'es-toolkit/compat';
import { useCampaignsListPageContext } from 'features/traffic/campaigns/TPCampaignsTab/CampaignsListPageContext';
import { useCallback } from 'react';
import { generatePath, useHistory, useParams, useRouteMatch } from 'react-router-dom';

type TabRouteInfo = {
  name: string;
  route: string;
};

const allRoutes: TabRouteInfo[] = [
  {
    name: 'Campaigns',
    route: trafficCampaignsRootPath,
  },
  {
    name: 'Assets',
    route: trafficProjectAssetsPath,
  },
  {
    name: 'Events',
    route: trafficProjectEventsPath,
  },
  {
    name: 'JAS Assets',
    route: trafficProjectJASAssetsPath,
  },
];

/**
 * TODO: Delete this component. Replace with <SearchControlledTabGroup />
 */
export const TabNavigation = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const { trafficProjectId } = useParams<{
    trafficProjectId: string;
  }>();

  const { hasEvent } = useCampaignsListPageContext();
  const Routes: TabRouteInfo[] = hasEvent ? allRoutes : allRoutes.filter((route) => route.name !== 'Events');
  const activeRoute: TabRouteInfo = find(Routes, (routeInfo) => match.path === routeInfo.route) ?? {
    name: 'Campaigns',
    route: trafficCampaignsRootPath,
  };

  const handleTabChange = useCallback(
    (name: string) => {
      const newTabRoute = find(Routes, (routeInfo) => routeInfo.name === name);
      if (newTabRoute) {
        history.push(
          generatePath(newTabRoute.route, {
            trafficProjectId,
          }),
        );
      }
    },
    [
      Routes,
      history,
      trafficProjectId,
    ],
  );

  return (
    <TabGroup data-cy="top-bar-tab" onChange={handleTabChange} value={activeRoute.name}>
      {Routes.map((routeInfo) => (
        <Tab data-cy={routeInfo.name} key={routeInfo.name} value={routeInfo.name}>
          {routeInfo.name}
        </Tab>
      ))}
    </TabGroup>
  );
};
